module.exports = __webpack_public_path__ + "fonts/Mukta-700-latin18.90bc65e.woff2";